import { render, staticRenderFns } from "./MostFrequentTopic.vue?vue&type=template&id=42e4b423&scoped=true"
import script from "./MostFrequentTopic.vue?vue&type=script&lang=js"
export * from "./MostFrequentTopic.vue?vue&type=script&lang=js"
import style0 from "./MostFrequentTopic.vue?vue&type=style&index=0&id=42e4b423&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e4b423",
  null
  
)

export default component.exports